<template>
  <f7-block>
    <f7-block-title>{{ $t('groupDashboard.access') }}</f7-block-title>
    <f7-list inset strong>
      <f7-list-item :title="$t('groupDashboard.inviteLinkEnabled')">
        <template #after>
          <f7-badge :color="data.inviteLinkEnabled ? 'green' : 'gray'">
            {{ data.inviteLinkEnabled ? $t('common.yes') : $t('common.no') }}
          </f7-badge>
        </template>
        <template #text>
          <span class="text-color-gray">{{ $t('groupDashboard.inviteLinkUses') }}: {{ fmt(data.inviteLinkUses) }}</span>
        </template>
      </f7-list-item>
      <f7-list-item :title="$t('groupDashboard.accessCodeEnabled')">
        <template #after>
          <f7-badge :color="data.accessCodeEnabled ? 'green' : 'gray'">
            {{ data.accessCodeEnabled ? $t('common.yes') : $t('common.no') }}
          </f7-badge>
        </template>
        <template #text>
          <span class="text-color-gray">{{ $t('groupDashboard.accessCodeUses') }}: {{ fmt(data.accessCodeUses) }}</span>
        </template>
      </f7-list-item>
    </f7-list>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
</script>